import React from 'react'
import img1 from "../assests/home-img1.png";



const AboutUs = () => {
  return (
    <>
      <section id="about" className="u-pb-60">
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-12 mx-auto">
              <h2 className="h1">About Us</h2>
              <div className="u-h-4 u-w-50 bg-primary rounded mt-4 u-mb-40 mx-auto"></div>
              <h3>
                Premisin - A Fully Furnished Dedicated and Co Working Office
                Space Provider in Raipur.
              </h3>
              <p>
                Welcome to a new era of workspace excellence! At Premisin, we
                invite you to take the leap and experience the remarkable
                difference in office spaces. With our premium offerings and
                state-of-the-art amenities, your journey to heightened
                productivity and success begins here.
              </p>
              <p>
                Premisin is your go-to provider for fully furnished office and
                co working space in Raipur. Our offerings include individual
                offices, dedicated workstations, cabin spaces, meeting rooms,
                conference rooms, and virtual office – all available at
                cost-effective prices.
              </p>

              <p>
                Flexible Pricing Models: Choose from per sqft or per seat
                pricing, depending on your unique requirements.
              </p>

              <p>
                Discover Our Convenient Locations: We have 11 centers within the
                city of Raipur which are located at premium location with 5 to
                10km distance from Airport and Railway Station.
              </p>

              <p>
                Easy Onboarding Process: Our onboarding process requires simple
                documentation and easy process which makes the clients a hassle
                free shifting and kickoff.
              </p>
            </div>
            <div className="text-center mx-auto mb-5">
              <button
                className="btn btn btn-rounded btn-primary mt-5"
                onClick={()=>window.gtag('event','about_button_click_schedule_office_visit')}
                data-toggle="modal"
                data-target="#sidenavmail"
              >
                Schedule a office space visit
              </button>
            </div>
            <div className="col-12 u-mt-30 text-center">
              <img
                className="lazyloadimg"
                src={img1}
                data-original="assets/img/home-img1.png"
                alt="Premisin"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutUs